import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  token: string;

  getToken() {
    this.token = localStorage.getItem('token');
  }

  constructor() {}

  ngOnInit(): void {
    this.getToken();
    let num = 20000000;
    console.log(
      num.toLocaleString('en-US', { style: 'currency', currency: 'NGN' })
    );
  }
}
